
export enum ActivityTypeEnum {
    'Activity' = 0,
    'NQA' = 1,
    'OQP' = 2,
    'Project' = 3,
    'NWT' = 4
}

export enum ActivitySubTypeEnum {
    'Qualified Direct Research - POE' = 0,
    'Qualified Direct Research - Non-POE' = 0,
    'Qualified Direct Supervision - POE' = 0,
    'Qualified Direct Supervision - Non-POE' = 0,
    'Qualified Direct Support - POE' = 0,
    'Qualified Direct Support - Non-POE' = 0,
    'Non-qualified' = 1,
    'NQ41/Q174' = 0,
    'Non-working Time' = 4
}

//This is used to Diplay in a Master Activity Screen 
//where we are displaying that 3 Radio buttons.
export enum MasterActivityTypeFlag {
    'Activity' = 0,
    'NQA' = 1,
    'NWT' = 4
}
